module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


//////////////////
// WEBPACK FOOTER
// ./~/vue2-google-maps/~/core-js/library/modules/$.is-object.js
// module id = ./node_modules/vue2-google-maps/node_modules/core-js/library/modules/$.is-object.js
// module chunks = 0